<p-dialog
  [(visible)]="visivel"
  (onHide)="visibleChange.emit(false)"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '920px', maxWidth: '96vw' }"
  [breakpoints]="{ '960px': '96vw' }"
  styleClass="dialog-wave-redesign venda-item-dialog">

  <!-- HEADER WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-shopping-cart" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.venda.selecionar_item.titulo' | translate }}</h2>
        <p>{{ 'contador_operar.venda.selecionar_item.subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">

    <!-- Busca -->
    <div class="vis-busca">
      <span class="p-input-icon-left w-full">
        <i class="pi pi-search"></i>
        <input pInputText type="text" class="w-full"
          pAutoFocus [autofocus]="!itemSelecionado"
          [(ngModel)]="busca"
          (input)="onBuscaChange()"
          [placeholder]="'contador_operar.venda.selecionar_item.buscar' | translate" />
      </span>
    </div>

    <!-- Tabela -->
    <p-table
      [value]="itens"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [loading]="loading"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      selectionMode="single"
      [(selection)]="itemSelecionado"
      (onRowSelect)="onRowSelect($event.data)"
      dataKey="id"
      styleClass="p-datatable-sm p-datatable-striped">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="codigoItem" style="width: 80px">
            {{ 'contador_operar.venda.selecionar_item.col_codigo' | translate }}<p-sortIcon field="codigoItem"></p-sortIcon>
          </th>
          <th pSortableColumn="nome">
            {{ 'contador_operar.venda.selecionar_item.col_nome' | translate }}<p-sortIcon field="nome"></p-sortIcon>
          </th>
          <th style="width: 130px">{{ 'contador_operar.venda.selecionar_item.col_categoria' | translate }}</th>
          <th style="width: 130px">{{ 'contador_operar.venda.selecionar_item.col_subcategoria' | translate }}</th>
          <th pSortableColumn="saldo" style="width: 90px">
            {{ 'contador_operar.venda.selecionar_item.col_saldo' | translate }}<p-sortIcon field="saldo"></p-sortIcon>
          </th>
          <th pSortableColumn="precoDeVenda" style="width: 130px" class="col-num">
            {{ 'contador_operar.venda.selecionar_item.col_preco' | translate }}<p-sortIcon field="precoDeVenda"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-produto>
        <tr [pSelectableRow]="produto"
          [class.row-selecionada]="itemSelecionado?.id === produto.id"
          (dblclick)="onRowDblClick(produto)">
          <td>{{ produto.codigoItem }}</td>
          <td>{{ produto.nome }}</td>
          <td>{{ produto.grupo?.nome || '-' }}</td>
          <td>{{ produto.subGrupo?.nome || '-' }}</td>
          <td>{{ produto.saldo }}</td>
          <td class="col-num">
            {{ produto.precoDeVenda | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center p-4 text-500">
            {{ 'contador_operar.venda.selecionar_item.vazio' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginação: mesmo arranjo das listagens do sistema (contagem + setas à
         esquerda, "Itens por página" + dropdown à direita), copiado da aba
         "Listagem de notas" (operar-cliente.component.html). A tabela é lazy,
         então a troca de página recarrega do backend via onPageChange. -->
    <div class="pagination-container">
      <div>
        <p-paginator
          (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'contador_operar.venda.selecionar_item.contagem' | translate"
          [first]="first"
          [rows]="rows"
          [totalRecords]="totalRecords"
          [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ 'contador_operar.notas.itens_por_pagina' | translate }}</span>
        <!-- appendTo="body": sem isso o painel é recortado pelo overflow-y do
             .p-dialog-content (medido: painel terminava 7px abaixo do corte e a
             opção "50" ficava cortada). Mesma solução da "Listagem de notas". -->
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
          appendTo="body">
        </p-dropdown>
      </div>
    </div>

    <!-- Campos de venda (quantidade x preço = subtotal) -->
    <div class="vis-venda-fields">
      <div class="vis-field vis-field--qtd">
        <label for="vis-qtd">{{ 'contador_operar.venda.selecionar_item.cantidad' | translate }}</label>
        <p-inputNumber
          inputId="vis-qtd"
          [(ngModel)]="quantidade"
          [min]="1"
          [locale]="cfgMoeda.locale"
          [showButtons]="true"
          buttonLayout="horizontal"
          decrementButtonClass="p-button-secondary"
          incrementButtonClass="p-button-secondary"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
          [disabled]="!itemSelecionado"
          styleClass="w-full">
        </p-inputNumber>
      </div>
      <div class="vis-field vis-field--preco">
        <!-- Com preço cadastrado o campo é somente-leitura (o funcionário não
             arbitra o preço do item do cliente). Sem preço cadastrado ele é
             digitável — senão o item entraria na nota por 0. Mesma regra do
             "dialog de preço zero" da página /vendas. -->
        <label *ngIf="precoEditavel" for="vis-preco">{{ 'contador_operar.venda.selecionar_item.precio' | translate }}</label>
        <span *ngIf="!precoEditavel" class="vis-field-label">{{ 'contador_operar.venda.selecionar_item.precio' | translate }}</span>
        <!-- prefix + decimal em vez de mode="currency": com PYG o modo currency
             trava a digitação no p-inputNumber (armadilha documentada).
             [monetaryMask]: máscara "caixa registradora" (7 → 0,07 → 0,70 →
             7,00), a mesma do diálogo "Definir preço de venda" da página
             /vendas e do cadastro de produtos. Com 0 casas (Guarani) a
             diretiva não intercepta e o campo vira inteiro simples. -->
        <p-inputNumber
          *ngIf="precoEditavel"
          #inputPreco
          inputId="vis-preco"
          [(ngModel)]="precoVenda"
          [min]="0"
          mode="decimal"
          [prefix]="prefixoMoeda"
          [locale]="cfgMoeda.locale"
          [minFractionDigits]="decimais"
          [maxFractionDigits]="decimais"
          [useGrouping]="true"
          [monetaryMask]="decimais"
          inputStyleClass="vis-input-preco"
          styleClass="w-full">
        </p-inputNumber>
        <div *ngIf="!precoEditavel"
          class="vis-subtotal-box"
          [class.vis-subtotal-box--vazio]="!itemSelecionado"
          [pTooltip]="itemSelecionado ? ('contador_operar.venda.selecionar_item.hint_preco_fixo' | translate) : ''"
          tooltipPosition="top">
          {{ precoVenda | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
        </div>
      </div>
      <div class="vis-field vis-field--subtotal">
        <span class="vis-field-label">{{ 'contador_operar.venda.selecionar_item.subtotal' | translate }}</span>
        <div class="vis-subtotal-box" [class.vis-subtotal-box--vazio]="!itemSelecionado">
          {{ subtotal | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
        </div>
      </div>
    </div>

    <!-- Uma linha só: explica o campo desabilitado OU avisa sobre o saldo.
         O slot reserva a altura de uma linha mesmo vazio: o p-dialog é centrado
         verticalmente, então qualquer mudança de altura aqui deslocaria a tabela
         inteira e quebraria o atalho de duplo clique (o 2º clique cairia em
         outra linha). -->
    <div class="vis-aviso-slot">
      <p *ngIf="!itemSelecionado" class="vis-aviso vis-aviso--hint">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        {{ 'contador_operar.venda.selecionar_item.hint_selecione' | translate }}
      </p>
      <!-- Preço pendente tem prioridade sobre o aviso de saldo: o slot é de UMA
           linha (altura fixa) e sem preço a seleção nem é permitida. -->
      <p *ngIf="itemSelecionado && precoInvalido" class="vis-aviso vis-aviso--alerta" aria-live="polite">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        {{ 'contador_operar.venda.selecionar_item.hint_preco_informar' | translate }}
      </p>
      <p *ngIf="itemSelecionado && !precoInvalido && excedeSaldo" class="vis-aviso vis-aviso--alerta" aria-live="polite">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        {{ 'contador_operar.venda.selecionar_item.aviso_saldo' | translate: { saldo: saldoDisponivel } }}
      </p>
    </div>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton
      type="button"
      class="p-button-secondary"
      [label]="'contador_operar.venda.selecionar_item.cancelar' | translate"
      (click)="cancelar()">
    </button>
    <button pButton
      type="button"
      icon="pi pi-check"
      [label]="'contador_operar.venda.selecionar_item.confirmar' | translate"
      [disabled]="!itemSelecionado || precoInvalido"
      (click)="confirmar()">
    </button>
  </ng-template>
</p-dialog>
